import React from 'react'

export function MicroButtonText({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return <span>{children}</span>
}
